import React, { useContext, lazy, Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../Navbar";
import { Footer } from "../Footer";
import ScrollToTopButton from "../ScrollToTopButton";
import MobileCategoryDrawer from "../MobileCategoryDrawer";
import { Context } from "../../context";
import { observer } from "mobx-react-lite";

// EN: Lazily load modals and sidebars to reduce the initial bundle size.
// PL: Leniwe ładowanie modali i pasków bocznych w celu zmniejszenia początkowego rozmiaru paczki.
const CartSidebar = lazy(() => import("../CartSidebar"));

// EN: A shared layout component for consistent UI across pages.
// PL: Wspólny komponent układu zapewniający spójny interfejs użytkownika na różnych stronach.
const MainLayout = observer(() => {
  const { cart } = useContext(Context);
  const location = useLocation();

  // EN: Determine if the current page is the Menu page
  // PL: Określ, czy bieżąca strona to strona Menu
  const isMenuPage = location.pathname.includes("/menu");

  // EN: Adjust main content margin based on whether the Menu is visible in the Navbar
  // PL: Dostosuj dopełnienie głównej treści w zależności od tego, czy Menu jest widoczony w Navbar
  return (
    <>
      <div
        className={`relative flex flex-col min-h-screen bg-stone-50 dark:bg-stone-950 text-stone-900 dark:text-stone-100 transition-all duration-300 ease-in-out ${
          cart.isOpen ? "md:mr-[30rem]" : "mr-0"
        }`}
      >
        {/* EN: Decorative global ambient lights and pattern */}
        <div
          className="fixed inset-0 opacity-[0.02] dark:opacity-[0.05] pointer-events-none z-0"
          style={{
            backgroundImage: `radial-gradient(circle, currentColor 1px, transparent 1px)`,
            backgroundSize: "24px 24px",
          }}
        />
        <div className="fixed top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-64 bg-amber-500/5 dark:bg-amber-500/10 blur-[100px] pointer-events-none z-0" />

        <div className="relative z-10 flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
              <Outlet />
            </div>
          </main>
          <Footer />
        </div>
      </div>

      <Suspense fallback={null}>
        <CartSidebar />
      </Suspense>

      <ScrollToTopButton />

      {isMenuPage && <MobileCategoryDrawer />}
    </>
  );
});

export default MainLayout;
